import api from './api'

export default {
  home() {
    return api.get('/')
  },
}
